<div
  [matTooltip]="tooltip()"
  [matTooltipDisabled]="!tooltip()"
  class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium"
>
  <div
    class="size-1.5 rounded-full"
    [class.bg-green-9]="state().status === entityStatus.ACTIVE"
    [class.bg-amber-9]="state().status === entityStatus.DEACTIVATED"
    [class.bg-red-9]="state().status === entityStatus.DELETED"
  ></div>
  {{ state().status | stateStatusDisplay }}
</div>
